module.exports = __webpack_public_path__ + "static/media/激光切割电子鼓.214f144f.png";